// extracted by mini-css-extract-plugin
module.exports = {"D3Serues":"D3Serues_D3Serues__UC9fr","pop":"D3Serues_pop__u8wGK"};